const REGIONS = ["Europe", "Asia", "Americas", "Africa", "Middle East", "Oceania"];

/**
 * Region shown as a pill selector. Auto-suggested from destination country on parent,
 * but user can override.
 */
export default function RegionPills({ value, onChange, suggested }) {
  return (
    <div data-testid="region-pills">
      <div className="flex items-center justify-between mb-2">
        <p className="ed-label !mb-0">REGION</p>
        {suggested && value !== suggested && (
          <button
            type="button"
            onClick={() => onChange(suggested)}
            className="text-[10px] font-mono tracking-widest uppercase text-[#CC1A1A] hover:underline"
            data-testid="region-auto-btn"
          >
            ↻ AUTO · {suggested}
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {REGIONS.map((r) => {
          const active = value === r;
          const isAuto = suggested === r && !value;
          return (
            <button
              type="button"
              key={r}
              onClick={() => onChange(r)}
              className={`min-h-[44px] px-4 font-mono text-[11px] tracking-[0.14em] uppercase transition-all border ${
                active
                  ? "bg-[#CC1A1A] border-[#CC1A1A] text-white"
                  : isAuto
                  ? "bg-transparent border-dashed border-[#CC1A1A] text-[#CC1A1A]"
                  : "bg-[#0E0E0E] border-[#2A2A2A] text-[#BEB3A6] hover:border-[#CC1A1A] hover:text-white"
              }`}
              data-testid={`region-${r.replace(/\s+/g, "-").toLowerCase()}`}
            >
              {r}
              {isAuto && <span className="ml-1 text-[9px]">(AUTO)</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
